import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/base.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 页面未显式捕获请求失败时，认证失效已由请求拦截器统一处理。
window.addEventListener('unhandledrejection', event => {
  if (event.reason?.isAuthExpired) event.preventDefault()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
